// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  offSiteLocations: [],
  offSiteLocation: {}
}

export const mutations = {
  SET_OFF_SITE_LOCATIONS(state, offSiteLocations) {
    state.offSiteLocations = offSiteLocations
  },
  SET_OFF_SITE_LOCATION(state, offSiteLocation) {
    state.offSiteLocation = offSiteLocation
  },
  ADD_OFF_SITE_LOCATION(state, offSiteLocation) {
    state.offSiteLocations.push(offSiteLocation)
  },
  EDIT_OFF_SITE_LOCATION(state, offSiteLocation) {
    const index = state.offSiteLocations.findIndex(
      el => el.offsite_location_uuid === offSiteLocation.offsite_location_uuid
    )
    if (index !== -1) {
      state.offSiteLocations.splice(index, 1, offSiteLocation)
    }
  },
  DELETE_OFF_SITE_LOCATION(state, id) {
    const index = state.offSiteLocations.findIndex(
      el => el.offsite_location_uuid === id
    )
    if (index !== -1) state.offSiteLocations.splice(index, 1)
  }
}

export const actions = {
  fetchOffSiteLocations({ commit }, payload) {
    return ApiService.fetchOffSiteLocations(payload)
      .then(res => {
        const result = res.data
        const offSiteLocations = result.data
        commit('SET_OFF_SITE_LOCATIONS', offSiteLocations)
      })
      .catch(error => {
        throw error
      })
  },
  addOffSiteLocation({ commit }, payload) {
    return ApiService.addOffSiteLocation(payload)
      .then(res => {
        const offSiteLocation = res.data
        commit('ADD_OFF_SITE_LOCATION', offSiteLocation)
      })
      .catch(error => {
        throw error
      })
  },
  editOffSiteLocation({ commit }, payload) {
    return ApiService.editOffSiteLocation(payload)
      .then(res => {
        const offSiteLocation = res.data
        commit('EDIT_OFF_SITE_LOCATION', offSiteLocation)
        commit('SET_OFF_SITE_LOCATION', offSiteLocation)
      })
      .catch(error => {
        throw error
      })
  },
  deleteOffSiteLocation({ commit }, payload) {
    return ApiService.deleteOffSiteLocation(payload)
      .then(() => {
        commit('DELETE_OFF_SITE_LOCATION', payload.offsite_location_uuid)
      })
      .catch(error => {
        throw error
      })
  }
}
